import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useTracks() {
  const [tracks, setTracks] = useState([]);
  const reload = useCallback(() => api.get("/tracks").then((r) => setTracks(r.data)), []);
  useEffect(() => {
    reload();
  }, [reload]);
  return { tracks, reload };
}
